export default "__VITE_ASSET__BqYe1lcp__"